import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomFooter = () => {
    const { t } = useTranslation();
    const gotoLink = (address) => {
        if (address.length > 0) {
            window.open(address, '_blank');
        }
    };

    return (
        <div className="seismic-engagement-viewer-custom-footer">
            <div className="footer-content">
                <div className="links">
                    <div className="link-item" onClick={() => gotoLink('http://go.microsoft.com/fwlink/?LinkId=521839')}>
                        <span>{t('LIVE_SEND_VIEWER_FOOTER_PRIVACY_AND_COOKIES')}</span>
                    </div>
                    <div className="link-item">
                        <span>{`${new Date().getFullYear()} ${t('LIVE_SEND_VIEWER_FOOTER_CORPORATION')}`}</span>
                    </div>
                    <div className="link-item" onClick={() => gotoLink('https://go.microsoft.com/fwlink/?LinkID=206977')}>
                        <span>{t('LIVE_SEND_VIEWER_FOOTER_TERMS_OF_USE')}</span>
                    </div>
                </div>
                <p className="text">{t('LIVE_SEND_VIEWER_FOOTER_HOSTED_BY')}</p>
            </div>
        </div>
    );
};

export default CustomFooter;
